import { styleOverrides } from "./styleOverrides";

const MuiTextField = {
  styleOverrides,
};

export { MuiTextField };
